import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class ContribuinteService {

  private apiUrl = environment.API_URL

  constructor(private http: HttpClient) { }

  getDadosListaBic() {
    return this.http.get(`${this.apiUrl}/contribuinte/solicitacao/tiposSolicitacao`);
  }

  criarSolicitacao(obj) {
    return this.http.post(`${this.apiUrl}/contribuinte/solicitacao`, obj);
  }

  criarCadastroContribuinte(codigoCadastro) {
    return this.http.get(`${this.apiUrl}/contribuinte/autoCadastro/contribuintePF/${codigoCadastro}`);
  }

  pesquisarProprietario(cpfCnpj: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/contribuinte/cadastro/cpfCnpj/${cpfCnpj}`);
  }

  // Consulta na base Sfera (SEFAZ/TO)
  consultarCadastroCompletoSfera(cpfCnpj: string) {
    return this.http.get(`${this.apiUrl}/contribuinte/cadastro/cadastroCompleto/${cpfCnpj}`);
  }

  // Consulta no b-Cadastros (Receita Federal)
  consultarCpfBcadastro(cpf: string) {
    return this.http.get(`${this.apiUrl}/cadastros/b-cadastro/dfe/cpf/${cpf}`);
  }

  consultarCnpjBcadastro(cnpj: string) {
    return this.http.get(`${this.apiUrl}/cadastros/b-cadastro/dfe/cnpj/${cnpj}`);
  }
}
